module.exports = __webpack_public_path__ + "img/ctrl-cross-resonance-stub-up-+i.1e51242a.svg";